// React
import React from "react";
import CalendarEdit from "./CalendarEdit";

const CalendarEditTvShows = props => (
    <CalendarEdit {...props} calendarType="tvshows" />
);
export default CalendarEditTvShows;